import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { IdSettings, IdStudentData } from '@shared/components/view-id/types';
import { MediaService } from '@shared/services/media';

import { ViewIdCodeFormats } from '../../constants';
import { setGradeSpecificColors, setHighlightColor } from '../../utils/view-id.utils';

@Component({
  selector: 'mg-view-id-mingasso',
  templateUrl: './view-id-mingasso.component.html',
  styleUrls: ['./view-id-mingasso.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewIdMingassoComponent implements AfterViewInit, OnChanges {
  // Children

  @ViewChild('container', { static: false }) container: ElementRef;

  // Inputs

  @Input() studentData: IdStudentData;
  @Input() settings: IdSettings;
  @Input() readonly: boolean;
  @Input() previewMode: boolean;

  // Outputs

  @Output() changePhoto = new EventEmitter<IdStudentData>();

  public ViewIdCodeFormats = ViewIdCodeFormats; // Expose enum to template

  // Constructor

  constructor(public media: MediaService, public domSanitizer: DomSanitizer) {}

  // Lifecycle Hooks

  ngAfterViewInit(): void {
    this._setColorStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.settings && this.settings) {
      this._setColorStyles();
    }
  }

  // Private Methods

  private _setColorStyles() {
    this._setFontColorProperty(this.settings.idFontColor);
    this._setBackgroundColorProperty(this.settings.idBackgroundColor);
    this._setSecurityStripColorProperty(this.settings.idBackgroundColor);
  }

  private _setFontColorProperty(hexColor: string) {
    if (this.settings.idEnableGradeColors) {
      hexColor = setGradeSpecificColors(hexColor, this.studentData.grade, this.settings.idGradeColors, 'font');
    }

    if (this.container) {
      this.container.nativeElement.style.setProperty('--dynamic-font-color', hexColor);
    }
  }

  private _setBackgroundColorProperty(hexColor: string) {
    if (this.settings.idEnableGradeColors) {
      hexColor = setGradeSpecificColors(hexColor, this.studentData.grade, this.settings.idGradeColors, 'background');
    }

    if (this.container) {
      this.container.nativeElement.style.setProperty('--dynamic-background-color', hexColor);
    }
  }

  private _setSecurityStripColorProperty(hexColor: string) {
    if (this.settings.idEnableGradeColors) {
      hexColor = setGradeSpecificColors(hexColor, this.studentData.grade, this.settings.idGradeColors, 'background');
    }

    hexColor = setHighlightColor(hexColor);

    if (this.container) {
      this.container.nativeElement.style.setProperty('--dynamic-security-strip-color', hexColor);
    }
  }

  /** @todo turn into pipe */
  public formatYear(year: number): string {
    return `${year} / ${year + 1}`;
  }
}
